import React, { useContext } from 'react';
import { View, Text, StyleSheet, TouchableOpacity, FlatList } from 'react-native';
import { MaterialCommunityIcons } from '@expo/vector-icons';
import ModalWrapper from '../../components/Modals/ModalWrapper';
import { MainColors } from '../../constants/Colors';
import FontSizes from '../../constants/FontSizes';
import LinkStyleButton from '../../components/Buttons/LinkStyleButton';
import { AuthContext } from '../../context/AuthProvider';
import { OrganizationContext } from '../../context/OrganizationProvider';

const SwitchOrganizationModal = (props) => {
    const { organizations } = useContext(AuthContext);
    const { organizationId, setOrganizationId } = useContext(OrganizationContext);

    const onSelectButtonPressedHandler = (organizationId) => {
        setOrganizationId(organizationId);
    }

    return (
        <ModalWrapper visible={props.visible}
            onModalBackgroundPressed={props.onModalBackgroundPressed}>
            <View style={styles.container}>
                <View style={styles.headerContainer}>
                    <Text style={styles.title}>Organizations</Text>
                    <TouchableOpacity onPress={props.onCloseIconPressed} accessibilityLabel='Close'>
                        <MaterialCommunityIcons name="close" size={16} color={MainColors.mediumGray} />
                    </TouchableOpacity>
                </View>
                <FlatList
                    data={organizations}
                    keyExtractor={(item) => item.organizationId.toString()}
                    renderItem={({ item }) => (
                        <View key={item.organizationId} style={styles.orgListItemContainer}>
                            <Text style={styles.organizationName} numberOfLines={1}>{item.organizationName}</Text>
                            {item.organizationId === organizationId ? (
                                <Text style={styles.currentOrgText}>Current</Text>
                            ) : (
                                    <LinkStyleButton style={styles.selectButton}
                                        onPress={() => onSelectButtonPressedHandler(item.organizationId)} 
                                        buttonText='Select'
                                        accessibilityLabel='Select'
                                        accessibilityHint='Press this button to select the organization to switch to'
                                    />
                                )}
                        </View>
                    )}
                />
            </View>
        </ModalWrapper>
    )
}

const styles = StyleSheet.create({
    container: {
        paddingHorizontal: 20,
        width: '100%'
    },
    headerContainer: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        borderBottomWidth: 1,
        borderBottomColor: MainColors.faintGray,
        paddingBottom: 10
    },
    title: {
        fontSize: FontSizes.medium,
        fontWeight: '600',
        color: MainColors.darkGray,
        textAlign: 'center',
    },
    orgListItemContainer: {
        marginTop: 15,
        flexDirection: 'row',
        justifyContent: 'space-between',
    },
    organizationName: {
        fontSize: FontSizes.medium,
        color: MainColors.darkGray,
        paddingRight: 5,
        width: '80%'
    },
    selectButton: {
        fontSize: FontSizes.medium,
    },
    currentOrgText: {
        color: MainColors.lightGray,
        fontStyle: 'italic',
        fontSize: FontSizes.medium,
        fontWeight: '500'
    }
});

export default SwitchOrganizationModal;